import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  purpose: "",
  name: "",
};

const apiKeyFormSlice = createSlice({
  name: "apiKeyForm",
  initialState,
  reducers: {
    setApiKeyForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetApiKeyForm: () => initialState,
  },
});

export const { setApiKeyForm, resetApiKeyForm } = apiKeyFormSlice.actions;
export default apiKeyFormSlice.reducer;
